import MobileSettingsMenuItem from "./mobile_settings_menu_item";

export default class MobileSettingsMenu {
  menuItems = [];
  onClickBack = () => {};
  title = "";
  showBackButton = false;

  constructor(options = {}) {
    this._el = document.createElement("div");
    this._listElement = document.createElement("ul");
    this.initOptions(options);
    this.setupList();
    this.buildMenu();
    this.hide();
  }

  get listElement() {
    return this._listElement;
  }

  initOptions(options) {
    this.menuItems = options.menuItems.filter((item) => { return item.enabled });
    this.onClickBack = options.onClickBack;
    this.title = options.title;
    this.showBackButton = options.showBackButton;
  }

  el() {
    return this._el;
  }

  buildMenu() {
    this.el().className = "vjs-settings-button__bottomsheet__menu"
    const titleBar = document.createElement("div")
    titleBar.className = "vjs-settings-button__bottomsheet__menu__title-bar"
    const title = document.createElement("span")
    title.className = "vjs-settings-button__bottomsheet__menu__title"
    title.textContent = this.title

    if (this.showBackButton) {
      const back = document.createElement("div")
      back.className = "vjs-settings-button__bottomsheet__menu__back"
      back.onclick = () => {
        this.onClickBack();
      }
      titleBar.appendChild(back)
    }
    titleBar.appendChild(title)

    this.el().appendChild(titleBar)

    const listContainer = document.createElement("div");
    listContainer.className = "vjs-settings-button__bottomsheet__menu__list-container";
    listContainer.appendChild(this.listElement);
    this.el().appendChild(listContainer);
  }

  setupList() {
    this.listElement.setAttribute("role", "menu");
    this.listElement.classList.add("vjs-settings-button__bottomsheet__menu__list");
    this.appendDataSettingsAttribute(this.listElement);

    this.menuItems.forEach((item, index) => {
      this.listElement.appendChild(this.createListItem(item, index));
    });
  }

  updateList(menuItems) {
    this.listElement.innerHTML = "";
    menuItems.forEach((item, index) => {
      this.listElement.appendChild(this.createListItem(item, index));
    });

    this.menuItems = menuItems;
  }

  createListItem(item, index) {
    const menuItem = new MobileSettingsMenuItem({
      label: item.label,
      activeLabel: item.activeLabel,
      onClickCallback: this.createItemClickListener(item.onClick, index),
      menuType: item.menuType,
    });
    return menuItem.el();
  }

  createItemClickListener(onClick, index) {
    return () => {
      this.menuItems = this.menuItems.map((menuItem, selectedIndex) => {
        if (index !== selectedIndex && menuItem.menuType === "checked")
          return {
            ...menuItem,
            menuType: "",
          };

        if (index === selectedIndex && menuItem.menuType !== "arrow" && menuItem.menuType !== "uncheckable")
          return {
            ...menuItem,
            menuType: "checked",
          };

        return menuItem;
      });

      this.updateList(this.menuItems);

      onClick();
    };
  }

  show() {
    this.el().style.display = "flex";
  }

  hide() {
    this.el().style.display = "none";
  }

  displayStatus() {
    return getComputedStyle(this.el()).display;
  }

  toggle() {
    if (this.displayStatus() == "none") {
      this.show();
    } else {
      this.hide();
    }
  }

  appendDataSettingsAttribute(el) {
    el.setAttribute("data-settings-menu", `${this.title.toLowerCase().replaceAll(" ","-")}`);
  }
}